export const UNSUPPORTED_SHIPPING_LOCATIONS_MESSAGE =
  'We don’t support shipping for these locations yet. Please contact support@tutulist.com.';

const normalizeCarrierName = value => {
  if (value === null || value === undefined) {
    return null;
  }

  const normalized = String(value)
    .trim()
    .toLowerCase()
    .replace(/[_-]+/g, ' ')
    .replace(/\s+/g, ' ');

  return normalized || null;
};

const matchesCanadaPost = value => {
  const normalized = normalizeCarrierName(value);
  if (!normalized) {
    return false;
  }

  return normalized.includes('canada post') || normalized.replace(/\s+/g, '').includes('canadapost');
};

const getCarrierNameCandidates = carrier => {
  if (typeof carrier === 'string') {
    return [carrier];
  }

  if (!carrier || typeof carrier !== 'object') {
    return [];
  }

  return [
    carrier.provider,
    carrier.providerName,
    carrier.provider_name,
    carrier.carrier,
    carrier.carrierName,
    carrier.carrier_name,
    carrier.name,
    carrier.servicelevel?.provider,
    carrier.serviceLevel?.provider,
    carrier.servicelevel?.carrier,
    carrier.serviceLevel?.carrier,
  ];
};

export const isCanadaPostCarrier = carrier =>
  getCarrierNameCandidates(carrier).some(matchesCanadaPost);

export const isSupportedShippingCarrier = carrier => !isCanadaPostCarrier(carrier);

export const filterSupportedShippingCarriers = carriers =>
  Array.isArray(carriers) ? carriers.filter(isSupportedShippingCarrier) : [];
